import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { ticketEffects } from 'src/app/root-store/ticket-store/effects';
import { reducer, ticketStoreFeatureKey } from 'src/app/root-store/ticket-store/ticket-store.reducers';
import { EnvironmentProviders } from '@angular/core';

export const provideTicketStore = (): EnvironmentProviders[] => [
    provideState(ticketStoreFeatureKey, reducer),
    provideEffects(ticketEffects)
];
